import { injectable } from "inversify";
import { type IService, Logger } from "@designboticteam/core";
import { createStore } from "./store";

@injectable()
class MapStoreService implements IService {
	public readonly serviceName = "🗺️ MapStoreService";
	private readonly logger = new Logger(`🌍 MAP | ${this.serviceName}`, {
		color: "#ffffff",
		backgroundColor: "#00aa00",
	});

	public readonly store = createStore();

	public get state() {
		return this.store.getState();
	}

	public get setState() {
		return this.store.setState;
	}

	public get subscribeToState() {
		return this.store.subscribe;
	}

	constructor() {
		this.logger.log("constructed");
	}

	public initialize(): void {
		this.logger.log("initialized");
	}

	public dispose(): void {
		this.store.setState(this.store.getInitialState());
		this.logger.log("disposed");
	}
}

export { MapStoreService };
